// ---------------------------------------------------------------------------
// Período — presets calculados no fuso America/Sao_Paulo (BRT = UTC-3, sem
// horário de verão desde 2019). Calcular no fuso do BR (e não no do browser)
// evita erro de 1 dia na virada da meia-noite, já que o backend agrupa em BRT.
//
// Compartilhado entre o relatório de envios e o relatório do SmartFilter.
// ---------------------------------------------------------------------------

export const BRT_OFFSET = '-03:00'
export const MAX_CUSTOM_DAYS = 90 // teto do intervalo personalizado (custo da contagem + retenção)

export const PERIOD_PRESETS = [
  { key: 'today', label: 'Hoje' },
  { key: '7d', label: '7 dias' },
  { key: '30d', label: '30 dias' },
  { key: 'custom', label: 'Personalizado' },
]

// Data "hoje" em BRT no formato YYYY-MM-DD, independente do fuso do browser.
export function brtToday() {
  const brt = new Date(Date.now() - 3 * 60 * 60 * 1000)
  return brt.toISOString().slice(0, 10)
}

// Soma (ou subtrai) dias a uma data YYYY-MM-DD e devolve outra YYYY-MM-DD.
export function addDaysISO(isoDate, days) {
  const d = new Date(`${isoDate}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

// Traduz um preset (ou intervalo custom) num range concreto. Devolve:
//   dateBegin  -> início do 1º dia (00:00 BRT)
//   dateEnd    -> início do dia seguinte ao último (00:00 BRT) — limite EXCLUSIVO
//   startDay / endDayInclusive -> dias YYYY-MM-DD para montar o eixo do gráfico
//   incomplete -> custom sem as duas datas (não vira uma janela "de verdade")
export function periodToRange(period, customStart, customEnd) {
  const today = brtToday()

  if (period === 'custom' && (!customStart || !customEnd)) {
    return { incomplete: true, dateBegin: null, dateEnd: null, startDay: null, endDayInclusive: null }
  }

  let startDay
  let endDayInclusive

  if (period === 'today') {
    startDay = today
    endDayInclusive = today
  } else if (period === '7d') {
    startDay = addDaysISO(today, -6)
    endDayInclusive = today
  } else if (period === 'custom' && customStart && customEnd) {
    startDay = customStart <= customEnd ? customStart : customEnd
    endDayInclusive = customStart <= customEnd ? customEnd : customStart
    // Teto de segurança no intervalo personalizado.
    if (addDaysISO(startDay, MAX_CUSTOM_DAYS - 1) < endDayInclusive) {
      startDay = addDaysISO(endDayInclusive, -(MAX_CUSTOM_DAYS - 1))
    }
  } else {
    // default e '30d'
    startDay = addDaysISO(today, -29)
    endDayInclusive = today
  }

  return {
    dateBegin: `${startDay}T00:00:00${BRT_OFFSET}`,
    dateEnd: `${addDaysISO(endDayInclusive, 1)}T00:00:00${BRT_OFFSET}`,
    startDay,
    endDayInclusive,
  }
}

// Lista de dias YYYY-MM-DD de startDay até endDayInclusive (para preencher o
// gráfico com zeros nos dias sem movimento, mantendo o eixo contínuo).
export function daysBetween(startDay, endDayInclusive) {
  const out = []
  let d = startDay
  let guard = 0
  while (d && endDayInclusive && d <= endDayInclusive && guard <= 400) {
    out.push(d)
    d = addDaysISO(d, 1)
    guard++
  }
  return out
}

// Rótulo humano do período aplicado (usado no cabeçalho dos relatórios).
export function periodLabelOf(appliedPeriod, startDay, endDayInclusive, moment) {
  if (appliedPeriod === 'today') return 'Hoje'
  if (appliedPeriod === '7d') return 'Últimos 7 dias'
  if (appliedPeriod === '30d') return 'Últimos 30 dias'
  if (appliedPeriod === 'custom' && startDay && endDayInclusive) {
    if (moment) return `${moment(startDay).format('DD/MM/YYYY')} – ${moment(endDayInclusive).format('DD/MM/YYYY')}`
    return `${startDay} – ${endDayInclusive}`
  }
  return 'Personalizado'
}
